import Header from "../components/Header";
import Hero from "../components/Hero";
import WeeklySpecial from "../components/WeeklySpecial";
import Events from "../components/Events";
import About from "../components/About";
import Gallery from "../components/Gallery";
import Menu from "../components/Menu";
import Reviews from "../components/Reviews";
import Hours from "../components/Hours";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import useReveal from "../lib/useReveal";

export default function HomePage() {
  useReveal();
  return (
    <div data-testid="home-page" className="overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <WeeklySpecial />
        <Events />
        <About />
        <Gallery />
        <Menu />
        <Reviews />
        <Hours />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
